const TOKEN_KEY = 'token';
const TIPO_CLIENTE = 'TIPO_CLIENTE';
const TIPO_CLIENTE_EMPRESA = 'TIPO_CLIENTE_EMPRESA';
const ID_CLIENTE_EMPRESA = 'ID_CLIENTE_EMPRESA';
const ID_CLIENTE_PARTICULAR = 'ID_CLIENTE_PARTICULAR';

const setToken = (token) => {
    localStorage.setItem(TOKEN_KEY, token);
}

const getToken = () => {
    return localStorage.getItem(TOKEN_KEY);
}

const deleteToken = () => {
    localStorage.removeItem(TOKEN_KEY);
}

const setEmpresaCliente = (data) => {
    localStorage.setItem(TIPO_CLIENTE_EMPRESA,data);
}

const getEmpresaCliente = () => {
    let tipo = localStorage.getItem(TIPO_CLIENTE_EMPRESA);
    return JSON.parse(tipo);
}



export {setToken,getToken,deleteToken, setEmpresaCliente, getEmpresaCliente}